<template>
    <div class="question-filter-main">
        <div class="question-filter-box">
            <div class="question-filter-box-left" v-if="btnTree">
                <button @click="$emit('treeshow')">知识树</button>
            </div>
            <div class="question-filter-box-right">
                <!-- 搜索 -->
                <div class="filter-row filter-row-one" v-if="!this.filterhide.includes('search')">
                    <el-input @keydown.native.13="getTestList" class="filter-lookfor" placeholder="搜索试题ID/试题名称" v-model="formdata.search_text">
                        <el-select slot="prepend" v-model="formdata.search_mode" v-if="!this.filterhide.includes('search_mode')">
                            <el-option label="精确搜索" :value="0"></el-option>
                            <el-option label="模糊搜索" :value="1"></el-option>
                            <el-option label="材料ID" :value="2"></el-option>
                        </el-select>
                        <div class="filter-lookfor-btn" slot="append">
                            <span class="iconfont icon-jianpan" v-if="!this.filterhide.includes('search_latex')" @click="latexPopView = true"></span>
                            <!-- <span class="iconfont icon-xiangji" v-if="!this.filterhide.includes('search_pic')"></span> -->
                            <el-button @click="getTestList"><span class="iconfont icon-sousuo"></span></el-button>
                            <latexPop v-if="latexPopView" @latexPopClose="latexPopView = false" @latexPopLookFor="latexPopLookFor"></latexPop>
                        </div>
                    </el-input>
                </div>
                <!-- 筛选项 -->
                <el-row :gutter="10" class="filter-row" ref="filters" id="filters">
                    <el-col :span="rowcol" class="filter-item" v-if="!this.filterhide.includes('department')">
                        <label class="label">学部学科</label>
                        <el-cascader
                            ref="departments"
                            v-model="departments"
                            :options="filterlist.dsoptions"
                            size="small"
                            placeholder="学部学科"
                        ></el-cascader>
                    </el-col>
                    <el-col  :span="rowcol"  class="filter-item" v-if="!this.filterhide.includes('year')">
                        <label class="label">年份</label>
                        <el-select v-model="formdata.year_id" clearable @change="getTestList">
                            <el-option v-for="item in filterlist.years" :value="item.id" :key="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-col>
                    <el-col  :span="rowcol"  class="filter-item" v-if="!this.filterhide.includes('area')">
                        <label class="label">地域</label>
                        <el-cascader
                            ref="area"
                            :title="area.length?titleArea:''"
                            :options="filterlist.provinces"
                            v-model="area"
                            clearable
                            :props="{label:'name',value:'id'}"
                            @change="optionDelAll(area,1)"
                            @active-item-change="provincesitemChange"
                        ></el-cascader>
                    </el-col>
                    <el-col  :span="rowcol"  class="filter-item" v-if="!this.filterhide.includes('school') && schools.length">
                        <label class="label">学校</label>
                        <el-select v-model="formdata.school_id" clearable @change="getTestList">
                            <el-option v-for="item in schools" :value="item.id" :key="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-col>
                    <el-col  :span="rowcol"  class="filter-item" v-if="!this.filterhide.includes('exam')">
                        <label class="label">考试类别</label>
                        <el-cascader
                            ref="exam"
                            :title="exam.length?titleExam:''"
                            :options="filterlist.source_types"
                            v-model="exam"
                            clearable
                            :props="{label:'name',value:'id'}"
                            @change="optionDelAll(exam,2)"
                            @active-item-change="examitemChange"
                        ></el-cascader>
                    </el-col>
                    <el-col  :span="rowcol"  class="filter-item" v-if="!this.filterhide.includes('type')">
                        <label class="label">题型</label>
                        <el-cascader
                            ref="types"
                            :title="types.length?titleType:''"
                            :options="categorys"
                            v-model="types"
                            clearable
                            :props="{label:'name',value:'id'}"
                            @change="optionDelAll(types,3)"
                        ></el-cascader>
                    </el-col>
                    <el-col  :span="rowcol"  class="filter-item" v-if="!this.filterhide.includes('level')&&filterlist.levels.length!=0">
                        <label class="label">能力层级</label>
                        <el-select  v-model="formdata.level_id" clearable @change="getTestList">
                            <el-option v-for="item in filterlist.levels" :key="item.id" :value="item.id" :label="item.title"></el-option>
                        </el-select>
                    </el-col>
                    <el-col  :span="rowcol"  class="filter-item" v-if="!this.filterhide.includes('difficulty')">
                        <label class="label">难度</label>
                        <el-select v-model="formdata.difficulty_type" clearable @change="getTestList">
                            <el-option value="1" label="简单题"></el-option>
                            <el-option value="2" label="中等题"></el-option>
                            <el-option value="3" label="难题"></el-option>
                        </el-select>
                    </el-col>
                    <el-col  :span="rowcol"  class="filter-item" v-if="!this.filterhide.includes('grade')" >
                        <label class="label">年级</label>
                        <el-select v-model="formdata.grade_ids" clearable @change="getTestList">
                            <el-option v-for="item in filterlist.grades" :value="item.id" :key="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-col>
                    <el-col  :span="rowcol"  class="filter-item" v-if="!this.filterhide.includes('is_verify')">
                        <label class="label">是否审核</label>
                        <el-select  v-model="formdata.is_verify" clearable @change="getTestList">
                            <el-option v-for="item in filterlist.is_verifys" :key="item.id" :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="question-filter-sort" v-if="!this.filterhide.includes('sort')||!this.filterhide.includes('page_all')">
            <div class="sort-left" v-if="!this.filterhide.includes('sort')">
                <button v-for="item in sortlist" :key="item.id" class="xes-button" :class="{active:formdata.sort_type == item.id}" @click="setSort(item)">
                    {{item.name}}
                    <span class="iconfont icon-paixuxiajiantou" :class="{'xia':item.dir==0,'shang':item.dir==1}"></span>
                </button>
            </div>
            <div class="sort-right" v-if="!this.filterhide.includes('page_all')">
                <button class="xes-button" @click="allPage">本页全选</button>
            </div>
            <slot name="filterSort" :list="testList"></slot>
        </div>
        <div class="question-filter-other">
            <p class="title" v-if="!this.filterhide.includes('total_num')">共计<b>{{formdata.alltotal}}</b>道题</p>
            <div class="page-size" v-if="!this.filterhide.includes('page_size')">
                <label>每页</label>
                <el-select  v-model="formdata.size" @change="getTestList">
                    <el-option
                        v-for="item in filterlist.page_list"
                        :key="item"
                        :value="item">
                    </el-option>
                </el-select>
                <label>题</label>
            </div>
        </div>
    </div>
</template>

<script>
import { httpRequest } from '../../../src/utils/ajax'
import latexPop from './latexPop' // 单个试题信息
export default {
    props: ['formdata', 'filterlist', 'treeview', 'filterhide', 'secret', 'actions','resizeEl','testList'],
    data(){
        return{
            rowcol:4,
            area:[],
            exam:[],
            types:[],
            titleArea:'',
            titleExam:'',
            titleType:'',
            sortlist:[
                {id:1,name:'综合排序',dir:0},
                {id:2,name:'试题难度',dir:0},
                {id:3,name:'使用次数',dir:0},
                {id:4,name:'正确率',dir:0},
            ],
            latexPopView:false,
            schools:[],
            observer:0
        }
    },
    mounted(){
        this.setRowCol()
    },
    components:{
        latexPop
    },
    computed:{
        btnTree(){
            return !this.treeview&&(!this.filterhide.includes('knowledge')||!this.filterhide.includes('cate_tree'))
        },
        categorys(){
            this.filterlist.categorys.forEach(one=>{
                this.filterlist.types.forEach(two=>{
                    if(one.type_id == two.id){
                        two.children ? two.children.push(one) : two.children = [one]
                    }
                    if(one.id == 0){
                        two.children ? two.children.unshift(one) : two.children = [one]
                    }
                })
            })
            return this.filterlist.types
        },
        departments:{
            get(){
                return [this.formdata.department,this.formdata.subject_id]
            },
            set(val){
                this.getFilter(val)
            }
        }
    },
    methods:{
        setRowCol(){
            this.$nextTick(el=>{
                let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
                let element = document.querySelector(this.resizeEl)
                this.observer = new MutationObserver((mutationList) => {
                    this.setWidth()
                })
                this.observer.observe(element, { attributes: true, attributeFilter: ['style'], attributeOldValue: true })
                this.setWidth()
            })
        },
        setWidth(){
            let w = document.querySelector(this.resizeEl).offsetWidth
            if(w < 360){
                this.rowcol = 24
            }
            if(w >= 360 && w<580){
                this.rowcol = 12
            }
            if(w >= 580 && w<800){
                this.rowcol = 8
            }
            if(w >= 800 && w<1020){
                this.rowcol = 6
            }
            if(w >= 1020 && w<1240){
                this.rowcol = 4
            }
            if(w >= 1240){
                this.rowcol = 3
            }
        },
        throwError (action) {
            // 若无相关地址，抛出错误
            if (!this.actions[action]) {
                throw new Error(`${action}地址为空！`)
            }
            return true
        },
        getFilter(val){
            this.schools.splice(0,this.schools.length)
            this.area.splice(0,this.area.length)
            this.exam.splice(0,this.exam.length)
            this.types.splice(0,this.types.length)
            let len=val.length
            len==0?this.formdata.department='':this.formdata.department=val[0]
            len==0?this.formdata.subject_id='':this.formdata.subject_id=val[1]
            this.formdata.page_num = 1
            this.$emit('get-filter')
        },
        latexPopLookFor(val){
            this.latexPopView = false
            this.formdata.search_text = this.formdata.search_text + val
            this.getTestList()
        },
        typeChange(){
            this.formdata.category_id = ''
            this.getTestList()
        },
        provincesitemChange(val){//地区联动
            if(val.length == 1){
                const isActionNotPass = this.throwError('getCities')
                if (!isActionNotPass) return
                let options = {
                    method: "POST",
                    params: {secret:this.secret,province_id:val[0]},
                    action: this.actions.getCities
                }
                httpRequest(options)
                .then((res)=>{
                    if(res.status == 100){
                        this.filterlist.provinces.forEach((element,index)=>{
                            if(element.id == val[0]){
                                this.filterlist.provinces[index].children = res.data.map(el=>{
                                    el.children = []
                                    return el
                                })
                                this.filterlist.provinces[index].children.unshift({id:'',name:'全部'})
                            }
                        })
                    }else{
                        this.$emit('status-error',res)
                    }
                })
                .catch((err)=>{
                    this.$emit('ajax-error',err)
                })
            }
            if(val.length == 2){
                const isActionNotPass = this.throwError('getCountries')
                if (!isActionNotPass) return
                let options = {
                    method: "POST",
                    params: {secret:this.secret,city_id:val[1]},
                    action: this.actions.getCountries
                }
                httpRequest(options)
                .then((res)=>{
                    if(res.status == 100){
                        this.filterlist.provinces.forEach((element,index)=>{
                            if(element.id == val[0]){
                                this.filterlist.provinces[index].children.forEach((two,num)=>{
                                    if(two.id == val[1]){
                                        // res.data.unshift({id:'',name:'全部'})
                                        this.filterlist.provinces[index].children[num].children = res.data
                                        this.filterlist.provinces[index].children[num].children.unshift({id:'',name:'全部'})
                                    }
                                })
                            }
                        })
                    }else{
                        this.$emit('status-error',res)
                    }
                })
                .catch((err)=>{
                    this.$emit('ajax-error',err)
                })
            }
        },
        examitemChange(val){
            if(val.length == 1){
                const isActionNotPass = this.throwError('getSequences')
                if (!isActionNotPass) return
                let options = {
                    method: "POST",
                    params: {secret:this.secret,type_id:val[0]},
                    action: this.actions.getSequences
                }
                httpRequest(options)
                .then((res)=>{
                    if(res.status == 100){
                       this.filterlist.source_types.forEach((element,index)=>{
                            if(element.id == val[0]){
                                res.data.unshift({id:'',name:'全部'})
                                this.filterlist.source_types[index].children = res.data
                            }
                        })
                    }else{
                        this.$emit('status-error',res)
                    }
                })
                .catch((err)=>{
                    this.$emit('ajax-error',err)
                })
            }
        },
        typesChange(val){

        },
        getSchools(){
            const isActionNotPass = this.throwError('getCities')
            if (!isActionNotPass) return
            let options = {
                method: "POST",
                params: {secret:this.secret,province_id:this.formdata.province_id,city_id:this.formdata.city_id,country_id:this.formdata.country_id},
                action: this.actions.getSchools
            }
            httpRequest(options)
            .then((res)=>{
                if(res.status == 100){
                    this.schools = res.data.school_list
                }else{
                    this.$emit('status-error',res)
                }
            })
            .catch((err)=>{
                this.$emit('ajax-error',err)
            })
        },
        optionDelAll(val,type){//处理地区/考试类别全部
            if(type == 1){
                this.formdata.province_id = val[0] || ''
                this.formdata.city_id = val[1] || ''
                this.formdata.country_id = val[2] || ''
                if(this.formdata.province_id){
                    this.getSchools()
                }else{
                    this.schools = []
                }
            }
            if(type == 2){
                this.formdata.source_type_id = val[0] || ''
                this.formdata.source_seq_id = val[1] || ''
            }
            if(type == 3){
                this.formdata.type_id = val[0] || ''
                this.formdata.category_id = val[1] || ''
            }
            this.getTestList()
            this.$nextTick(()=>{
                if(type == 1){
                    this.titleArea = this.$refs.area.$el.innerText
                }
                if(type == 2){
                    this.titleExam = this.$refs.exam.$el.innerText
                }
                if(type == 3){
                    this.titleType = this.$refs.types.$el.innerText
                }
            })
            var index = val.indexOf('')//判断数据里有没有空的
            if(index == -1) return
            val.splice(index,1)
        },
        getTestList(){
            this.formdata.page_num = 1
            this.formdata.year_id = this.formdata.year_id === null ? '' : this.formdata.year_id
            this.formdata.level_id = this.formdata.level_id === null ? '' : this.formdata.level_id
            this.formdata.difficulty_type = this.formdata.difficulty_type === null ? '' : this.formdata.difficulty_type
            this.formdata.grade_ids = this.formdata.grade_ids === null ? '' : this.formdata.grade_ids
            this.formdata.is_verify = this.formdata.is_verify === null ? '' : this.formdata.is_verify
            this.$emit('get-test-list')
        },
        setSort(item){
            if(this.formdata.sort_type == item.id){
                item.dir = item.dir == 1 ? 0 : 1
            }else{
                this.formdata.sort_type = item.id
            }
            this.formdata.is_asc_sort = item.dir
            this.getTestList()
        },
        clearData(){
            this.sortlist.forEach(el=>{
                el.dir = 0
            })
            this.area = []
        },
        allPage(){
            this.$emit('page-all')
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// packages/question-filter/src/filter.vue